export default function DownloadSection() {
  return (
    <>
      {/* Download CTA Section */}
      <section id="download" className="py-20 md:py-28 bg-gradient-to-br from-red-600 via-red-500 to-orange-400 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-40 h-40 rounded-full bg-white"></div>
          <div className="absolute bottom-10 right-10 w-60 h-60 rounded-full bg-white"></div>
          <div className="absolute top-1/2 left-1/3 w-20 h-20 rounded-full bg-yellow-300"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full px-4 py-1.5 mb-6">
            <i className="ri-gift-line text-yellow-300"></i>
            <span className="text-white text-sm font-medium">สมัครทันที รับสะสมได้ถึง 3,500+ เหรียญ!</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
            เริ่มดูซีรีส์<br />แล้วรับเงินได้เลย!
          </h2>
          <p className="text-white/80 text-lg md:text-xl mb-10 max-w-xl mx-auto">
            ฟรี 100% · สมัครด้วยเบอร์โทร · ถอนผ่าน USDT/USDC · ไม่ต้องลงทุน
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
            <a
              href="https://www.hongguo-drama.com/app/HongGuo.apk"
              className="flex items-center justify-center gap-3 bg-white text-red-500 px-8 py-4 rounded-full text-lg font-bold hover:scale-105 transition-transform cursor-pointer whitespace-nowrap"
            >
              <i className="ri-google-play-line text-2xl"></i>
              <div className="text-left">
                <div className="text-xs text-gray-400 font-normal">ดาวน์โหลดจาก</div>
                <div>Google Play</div>
              </div>
            </a>
            <a
              href="itms-services://?action=download-manifest&url=https://www.hongguo-drama.com/app/ios.plist"
              className="flex items-center justify-center gap-3 bg-white text-red-500 px-8 py-4 rounded-full text-lg font-bold hover:scale-105 transition-transform cursor-pointer whitespace-nowrap"
            >
              <i className="ri-apple-line text-2xl"></i>
              <div className="text-left">
                <div className="text-xs text-gray-400 font-normal">ดาวน์โหลดจาก</div>
                <div>App Store</div>
              </div>
            </a>
            <a
              href="https://line.me/ti/p/rwV4hTkrHJ"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center justify-center gap-3 bg-green-500 text-white px-8 py-4 rounded-full text-lg font-bold hover:scale-105 transition-transform cursor-pointer whitespace-nowrap"
            >
              <i className="ri-chat-smile-2-line text-2xl"></i>
              <div className="text-left">
                <div className="text-xs text-green-200 font-normal">ติดต่อผ่าน</div>
                <div>เพิ่ม LINE</div>
              </div>
            </a>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-6 text-white/70 text-sm">
            <span className="flex items-center gap-1"><i className="ri-shield-check-line text-green-300"></i> ปลอดภัย 100%</span>
            <span className="flex items-center gap-1"><i className="ri-download-line text-yellow-300"></i> ดาวน์โหลดฟรี</span>
            <span className="flex items-center gap-1"><i className="ri-coin-line text-yellow-300"></i> ไม่ต้องลงทุน</span>
            <span className="flex items-center gap-1"><i className="ri-bank-card-line text-green-300"></i> ถอน USDT/USDC</span>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-b from-gray-900 to-gray-800 text-white py-14">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
            {/* Brand */}
            <div className="md:col-span-2">
              <div className="flex items-center mb-4">
                <img
                  src="https://storage.readdy-site.link/project_files/56c41bf3-601b-4bf6-887a-7e03952d5d2d/218c8f37-84c2-4ce1-83b2-289940c337c2_logo.png?v=23227280e2aecf228e7afc5646e19210"
                  alt="Hongguo Drama"
                  className="h-10 w-auto object-contain"
                />
              </div>
              <p className="text-gray-400 text-sm leading-relaxed mb-5 max-w-xs">
                แพลตฟอร์มซีรีส์สั้นคุณภาพสูง พร้อมระบบรางวัลที่ยุติธรรม ให้คุณดูซีรีส์แล้วได้รับเงินจริง
              </p>
              <div className="flex gap-3">
                {["ri-facebook-fill", "ri-instagram-line", "ri-tiktok-line", "ri-youtube-line"].map((icon) => (
                  <a key={icon} href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-red-500 transition-colors cursor-pointer">
                    <i className={`${icon} text-sm`}></i>
                  </a>
                ))}
              </div>
            </div>
            {/* Links */}
            <div>
              <h4 className="font-bold mb-4 text-white">ลิงก์ด่วน</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                {["เกี่ยวกับเรา", "วิธีรับรางวัล", "ซีรีส์ยอดนิยม", "ชวนเพื่อน"].map((item) => (
                  <li key={item}><a href="#" rel="nofollow" className="hover:text-red-400 transition-colors cursor-pointer">{item}</a></li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-4 text-white">ช่วยเหลือ</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                {["ศูนย์ช่วยเหลือ", "นโยบายความเป็นส่วนตัว", "เงื่อนไขการใช้งาน", "ติดต่อเรา"].map((item) => (
                  <li key={item}><a href="#" rel="nofollow" className="hover:text-red-400 transition-colors cursor-pointer">{item}</a></li>
                ))}
              </ul>
            </div>
          </div>
          <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-gray-500 text-sm">
            <p>© 2024 Hongguo Drama. สงวนลิขสิทธิ์ทุกประการ</p>
            <p className="flex items-center gap-1">
              <i className="ri-map-pin-line text-red-400"></i>
              Bangkok, Thailand
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
